import React from 'react';
import { DollarSign, Users } from 'lucide-react';
import StatCard from './StatCard';

const StatsSection = ({ stats, loading, error }) => {
  if (error) {
    return (
      <div className="mb-10 p-4 rounded-lg border border-red-200 bg-red-50 text-sm text-red-600">
        {error}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
      <StatCard
        title="Pipeline Value"
        value={stats.pipelineValue}
        change={stats.pipelineChange}
        icon={DollarSign}
        loading={loading}
      />
      <StatCard
        title="New Leads (Today)"
        value={stats.newLeadsToday}
        subtitle={loading ? undefined : `vs ${stats.newLeadsYesterday} yesterday`}
        icon={Users}
        loading={loading}
      />
      <StatCard
        title="Action Required Leads"
        value={stats.actionRequired}
        subtitle={loading ? undefined : 'Leads waiting'}
        icon={Users}
        loading={loading}
      />
    </div>
  );
};

export default StatsSection;
